import { Classes, PanelProps, PanelStack2 } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import { Route } from 'react-router-dom';
import { Dialog } from 'vet-bones/components';

import { ROUTE } from 'src/constants/routes';
import { TEST_IDS } from 'src/constants/testIds';
import { ProjectResourceDialogFooter } from 'src/containers/ProjectResourceDialog/ProjectResourceDialogFooter';
import {
  ResourceTypePanel,
  ResourceTypePanelProps,
} from 'src/containers/ProjectResourceDialog/ResourceTypePanel/ResourceTypePanel';
import { ProjectResourceDialogFooterProps } from 'src/containers/ProjectResourceDialog/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export type ProjectResourceDialogProps = {
  initialPanelComponent?: React.ComponentType<any>;
};

export const ProjectResourceDialog: React.VFC<ProjectResourceDialogProps> = ({
  initialPanelComponent,
}) => {
  const dispatch = useReduxDispatch();

  const isOpen = useReduxSelector(
    (state) => state.ui.isProjectResourceDialogOpen
  );

  const [footerProps, setFooterProps] =
    React.useState<ProjectResourceDialogFooterProps>({});

  const initialPanel = React.useMemo(() => {
    const props: ResourceTypePanelProps = {
      setFooterProps,
    };
    return {
      renderPanel: (initialPanelComponent || ResourceTypePanel) as React.VFC<
        PanelProps<any>
      >,
      props,
    };
  }, [initialPanelComponent]);

  const handleClose = () => {
    dispatch(uiSlice.actions.toggledProjectResourceDialog({ isOpen: false }));
  };

  return (
    <Dialog
      autoFocus={false}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      className={classNames('sd-dialog-project-resource', 'sd-dialog-large')}
      closeIconTestId={TEST_IDS.dialog.closeIcon}
      enforceFocus={false}
      isOpen={isOpen}
      lazy={false}
      onClose={handleClose}
      title={copy.components.projectResourceDialog.title}
    >
      <Route path={ROUTE.PROJECT}>
        <div className={Classes.DIALOG_BODY}>
          <PanelStack2
            initialPanel={initialPanel}
            renderActivePanelOnly
            showPanelHeader={false}
          />
        </div>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <ProjectResourceDialogFooter {...footerProps} />
      </Route>
    </Dialog>
  );
};
